import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {BehaviorSubject, Observable, Subscriber} from 'rxjs';
import {filter, take} from "rxjs/operators";
import {L1L3AuthService} from "../services/l1-l3-auth.service";
import {TokenRefreshService} from "../services/token-refresh.service";

@Injectable({
  providedIn: 'root'
})
export class L3AuthGuard  {
  private refreshTokenSubject: BehaviorSubject<any>;
  private refreshed: boolean = false;

  constructor(private l1l3AuthService: L1L3AuthService,
              private tokenRefreshService: TokenRefreshService,
              private router: Router) {
    this.refreshTokenSubject = this.tokenRefreshService.getRefreshTokenSubject();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log("L3Guard - canActivate()")
    if (this.l1l3AuthService.getL3Token()) {
      return true;
    } else {
      return new Observable(subscriber => {
        this.requestL3(subscriber, state);
      });
    }
  }

  private requestL3(subscriber: Subscriber<boolean | UrlTree>, state: RouterStateSnapshot) {
    console.log('Call requestL3 in L3Guard... ');
    this.l1l3AuthService.requestL3Token().subscribe({
      next: () => {
        this.refreshed = false;
        subscriber.next(true);
      },
      error: err => {
        if ((err.status === 401 || err.status === 400) && !this.refreshed) {
          if (!this.tokenRefreshService.isRefreshTokenPending()) {
            console.log('401 - in L3Guard - starting refresh...');
            this.tokenRefreshService.startRefresh();
          }
          this.refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1))?.subscribe(() => {
            this.refreshed = true;
            this.requestL3(subscriber, state);
          });
        } else {
          console.log(err);
          this.l1l3AuthService.goToLogin(state?.url);
          // TODO keep an eye on
          //this.l1l3AuthService.logout();
        }
      }
    })

  }
}
